import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 17",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.805 12.471c-.26.26-.683.26-.943 0-.26-.26-.26-.682 0-.942l2.862-2.861-9.057-.001c-.335 0-.612-.247-.66-.568L2 8c0-.368.298-.667.667-.667h9.057L8.862 4.472c-.234-.234-.258-.6-.07-.86l.07-.082c.26-.26.682-.26.943 0l4 4 .015.015.038.044c.01.013.02.026.028.039.01.014.02.03.028.045l.019.036c.023.047.04.097.052.15.021.098.02.2-.004.298l-.01.042-.01.025c-.008.025-.018.05-.03.073l-.01.02-.035.058c-.024.034-.05.067-.081.097l.05-.056c-.012.015-.024.029-.037.042l-.013.014z"
	})
});
export default SvgArrowRight;
